/**
 * remove an item by mutating the original array
 * @param arrayName
 * @param itemName
 */
export function removeItemFromArray<T>(arrayName: Array<T>, itemName: T) {
   const index = arrayName.indexOf(itemName);
   if (index !== -1) {
      arrayName.splice(index, 1);
   }
}

/**
 * a function which can passed to Array.prototype.sort to alphabetize an array of strings
 * @param a string
 * @param b string
 * @returns number
 */
export function alphabetizeStrings(a: string, b: string): number {
   return a.localeCompare(b);
}
